var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-edit" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "Widget",
        { attrs: { title: (_vm.isNew ? "New" : "Edit") + " notification" } },
        [
          !_vm.isNew && _vm.isReceiving
            ? _c("Loader", { attrs: { size: 40 } })
            : _c(
                "Form",
                [
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "message" } },
                      [_vm._v("Message")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "message", type: "text" },
                        domProps: { value: _vm.notification.message },
                        on: {
                          change: function($event) {
                            return _vm.updateNotificationProperty(
                              $event,
                              "message"
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group row" }, [
                    _c(
                      "label",
                      { staticClass: "col-md-2", attrs: { for: "title" } },
                      [_vm._v("Title")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-5" }, [
                      _c("input", {
                        staticClass: "form-control",
                        attrs: { id: "title", type: "text" },
                        domProps: { value: _vm.notification.title },
                        on: {
                          change: function($event) {
                            return _vm.updateNotificationProperty(
                              $event,
                              "title"
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.recurrenceUM != "Once"
                    ? _c(
                        "div",
                        { staticClass: "form-group row" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "col-md-2",
                              attrs: { for: "notificationDateRange" }
                            },
                            [_vm._v("Date range")]
                          ),
                          _vm._v(" "),
                          _c("v-date-picker", {
                            staticClass: "col-md-5",
                            attrs: {
                              mode: "range",
                              id: "notificationDateRange"
                            },
                            model: {
                              value: _vm.calendarData,
                              callback: function($$v) {
                                _vm.calendarData = $$v
                              },
                              expression: "calendarData"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-group row" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "col-md-2",
                          attrs: { for: "recurrenceUM" }
                        },
                        [_vm._v("Recurrence UM")]
                      ),
                      _vm._v(" "),
                      _c("v-select", {
                        staticClass: "col-md-5",
                        attrs: {
                          clearable: false,
                          id: "recurrenceUM",
                          options: _vm.recurrenceUMOptions
                        },
                        on: { input: _vm.onRecurrenceUMSelect },
                        model: {
                          value: _vm.recurrenceUM,
                          callback: function($$v) {
                            _vm.recurrenceUM = $$v
                          },
                          expression: "recurrenceUM"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.recurrenceUM == "Hour"
                    ? _c("div", [
                        _c("div", { staticClass: "form-group row" }, [
                          _c(
                            "label",
                            {
                              staticClass: "col-md-2",
                              attrs: { for: "hourlyNotification" }
                            },
                            [_vm._v("Run the schedule every")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-2 display-flex",
                              staticStyle: { "align-items": "center" }
                            },
                            [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  id: "hourlyNotification",
                                  type: "number"
                                },
                                domProps: { value: _vm.notification.hours },
                                on: {
                                  change: function($event) {
                                    return _vm.updateNotificationProperty(
                                      $event,
                                      "hours"
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "pl-3" }, [
                                _vm._v("hours")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-md-2 display-flex",
                              staticStyle: { "align-items": "center" }
                            },
                            [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  id: "hourlyNotification1",
                                  type: "number"
                                },
                                domProps: { value: _vm.notification.minutes },
                                on: {
                                  change: function($event) {
                                    return _vm.updateNotificationProperty(
                                      $event,
                                      "minutes"
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "pl-3" }, [
                                _vm._v("minutes")
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group row" },
                          [
                            _c("label", { staticClass: "col-md-2" }, [
                              _vm._v("Start time")
                            ]),
                            _vm._v(" "),
                            _c("vue-timepicker", {
                              staticClass: "col-md-5",
                              attrs: { "hour-range": [[7, 19]] },
                              model: {
                                value: _vm.notification.startTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.notification, "startTime", $$v)
                                },
                                expression: "notification.startTime"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm.recurrenceUM == "Day"
                    ? _c("div", [
                        _c("div", { staticClass: "form-group row" }, [
                          _c("label", { staticClass: "col-md-2" }, [
                            _vm._v("On the following days")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-5 display-flex" },
                            _vm._l(_vm.weekdays, function(day, i) {
                              return i < 5
                                ? _c("div", { key: i, staticClass: "mr-3" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.weekdays[i],
                                          expression: "weekdays[i]"
                                        }
                                      ],
                                      attrs: { type: "checkbox" },
                                      domProps: {
                                        checked: Array.isArray(_vm.weekdays[i])
                                          ? _vm._i(_vm.weekdays[i], null) > -1
                                          : _vm.weekdays[i]
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.weekdays[i],
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  _vm.weekdays,
                                                  i,
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  _vm.weekdays,
                                                  i,
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(_vm.weekdays, i, $$c)
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.weekdayNames[i]))
                                    ])
                                  ])
                                : _vm._e()
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group row" },
                          [
                            _c("label", { staticClass: "col-md-2" }, [
                              _vm._v("Start time")
                            ]),
                            _vm._v(" "),
                            _c("vue-timepicker", {
                              staticClass: "col-md-5",
                              attrs: { "hour-range": [[7, 19]] },
                              model: {
                                value: _vm.notification.startTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.notification, "startTime", $$v)
                                },
                                expression: "notification.startTime"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm.recurrenceUM == "Once"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-group row" },
                          [
                            _c("label", { staticClass: "col-md-2" }, [
                              _vm._v("Start time")
                            ]),
                            _vm._v(" "),
                            _c("datetime", {
                              staticClass: "col-md-5",
                              model: {
                                value: _vm.notification.startTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.notification, "startTime", $$v)
                                },
                                expression: "notification.startTime"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.global == true
                    ? _c("div", { staticClass: "form-group row" }, [
                        _c(
                          "label",
                          {
                            staticClass: "col-md-2",
                            attrs: { for: "timezone" }
                          },
                          [_vm._v("Timezone")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-md-5" },
                          [
                            _c("v-select", {
                              attrs: {
                                id: "timezone",
                                options: _vm.getTimezoneOptions()
                              },
                              on: { input: _vm.onTimezoneSelect },
                              model: {
                                value: _vm.notification.timezone,
                                callback: function($$v) {
                                  _vm.$set(_vm.notification, "timezone", $$v)
                                },
                                expression: "notification.timezone"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "abc-checkbox abc-checkbox-primary mb-4" },
                    [
                      _c("input", {
                        attrs: { type: "checkbox", id: "isPublic" },
                        domProps: { checked: _vm.notification.public == true },
                        on: {
                          change: function($event) {
                            return _vm.togglePublic()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "isPublic" } }, [
                        _vm._v("Active")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "abc-checkbox abc-checkbox-primary mb-4" },
                    [
                      _c("input", {
                        attrs: {
                          type: "checkbox",
                          id: "isGlobal",
                          disabled: !_vm.showGlobalOption()
                        },
                        domProps: { checked: _vm.notification.global == true },
                        on: {
                          change: function($event) {
                            return _vm.toggleGlobal()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "isGlobal" } }, [
                        _vm._v("Global")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "abc-checkbox abc-checkbox-primary mb-4" },
                    [
                      _c("input", {
                        attrs: { type: "checkbox", id: "sendToAll" },
                        domProps: { checked: _vm.sendToAll },
                        on: {
                          change: function($event) {
                            return _vm.toggleSendToAll()
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "sendToAll" } }, [
                        _vm._v("Send to all")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.sendToAll == false
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-group mt-4" },
                          [
                            _c(
                              "label",
                              { attrs: { for: "notificationUsers" } },
                              [_vm._v("Select users")]
                            ),
                            _vm._v(" "),
                            _c("v-select", {
                              staticClass: "w-25",
                              attrs: {
                                clearable: false,
                                id: "notificationUsers",
                                options: _vm.availableUsers
                              },
                              on: { input: _vm.onUserSelect }
                            }),
                            _vm._v(" "),
                            _vm.selectedUsers.length > 0
                              ? _c("div", { staticClass: "mt-3" }, [
                                  _c("b", [_vm._v("Selected users")])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.selectedUsers, function(user) {
                              return _c("div", { key: user.id }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "p-2 display-flex w-25",
                                    staticStyle: {
                                      "justify-content": "space-between"
                                    }
                                  },
                                  [
                                    _c("div", [
                                      _c("i", { staticClass: "fa fa-user" }),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(user.firstName) +
                                          " " +
                                          _vm._s(user.lastName) +
                                          "\n                                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fa fa-close ml-4",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeUser(user)
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.errorsList, function(error, i) {
                    return _c(
                      "b-alert",
                      {
                        key: i,
                        staticClass: "alert-sm w-25",
                        attrs: {
                          variant: "danger",
                          show: _vm.errorsList.length > 0
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(error) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button-toolbar",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: {
                            click: function($event) {
                              return _vm.saveNotification()
                            }
                          }
                        },
                        [
                          _vm.isUpdating
                            ? _c("Loader")
                            : _c("span", [_vm._v("Save")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "default" },
                          on: {
                            click: function($event) {
                              return _vm.goBack()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        Back\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.isNew
                        ? _c(
                            "span",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    id: "deleteNotificationPopover",
                                    variant: "danger"
                                  }
                                },
                                [
                                  _vm.isDeleting
                                    ? _c("Loader")
                                    : _c("span", [_vm._v("Delete")])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  staticClass: "popover-danger",
                                  attrs: {
                                    target: "deleteNotificationPopover",
                                    placement: "top",
                                    show: _vm.popover
                                  },
                                  on: {
                                    "update:show": function($event) {
                                      _vm.popover = $event
                                    }
                                  }
                                },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c("div", { staticClass: "px-5" }, [
                                      _vm._v("Are you sure?")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "px-5 d-flex justify-content-center"
                                    },
                                    [
                                      _c(
                                        "b-button-toolbar",
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "success",
                                                size: "xs"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteNotification(
                                                    _vm.notification.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Yes\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                variant: "danger",
                                                size: "xs"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.popover = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    No\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                2
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "page-title" }, [
      _vm._v(
        "Notification                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    - "
      ),
      _c("span", { staticClass: "fw-semi-bold" }, [_vm._v("Detail")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }